import Edit from '../Edit/index'
export default Edit